import { useEffect, useState } from "react";
import { Grid, TextField, Select, MenuItem } from "../../../../components";
import {
  ColecoesService,
  TagsService,
  MarcasService,
} from "../../../../services";
import { responseErros } from "../../../../utils";
import { value } from "../../../../helpers";
import { Autocomplete } from "@mui/material";

const FormFiltroAvancado = ({
  valueInput,
  onChangeInput,
  onChangeMultiple,
}) => {
  const tagsService = new TagsService();
  const marcasService = new MarcasService();
  const colecoesService = new ColecoesService();
  const [tags, setTags] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [colecoes, setColecoes] = useState([]);

  useEffect(() => {
    buscarTags();
    buscarMarcas();
    buscarColecoes();
  }, []);

  const buscarTags = async function () {
    const filtros = {
      nonPaginated: true,
      ativado: true,
      tipo: "PRODUTO",
    };
    const result = await tagsService.getAll(filtros);
    if (!result.isAxiosError) {
      setTags(result.data);
    } else {
      responseErros(result);
    }
  };

  const buscarMarcas = async function (filter) {
    const result = await marcasService.getAll(filter);
    if (!result.isAxiosError) {
      setMarcas(result.data.rows);
    } else {
      responseErros(result);
    }
  };

  const buscarColecoes = async function (filter) {
    const result = await colecoesService.getAll(filter);
    if (!result.isAxiosError) {
      setColecoes(result.data.rows);
    } else {
      responseErros(result);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          id="codigo"
          name="codigo"
          label="Código"
          variant="outlined"
          fullWidth
          onChange={(event) => onChangeInput(event)}
          value={valueInput("codigo")}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id="codigoBarra"
          name="codigoBarra"
          label="Código Barras"
          variant="outlined"
          fullWidth
          onChange={(event) => onChangeInput(event)}
          value={valueInput("codigoBarra")}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id="descricao"
          name="descricao"
          label="Descrição"
          variant="outlined"
          fullWidth
          onChange={(event) => onChangeInput(event)}
          value={valueInput("descricao")}
        />
      </Grid>
      <Grid item xs={12}>
        <Select
          id="tipo"
          name="tipo"
          variant="outlined"
          label="Tipo"
          fullWidth
          onChange={(event) => onChangeInput(event)}
          value={valueInput("tipo")}
        >
          <MenuItem value="simples">Simples</MenuItem>
          <MenuItem value="grade">Grade</MenuItem>
          <MenuItem value="kit">Kit</MenuItem>
        </Select>
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          multiple
          id="tagsId"
          name="tagsId"
          options={tags}
          noOptionsText="Sem opções"
          autoHighlight
          filterSelectedOptions
          getOptionLabel={(option) => {
            return (
              <div>
                <i
                  className="ph-fill ph-bookmark-simple"
                  style={{ color: `${option?.cor}`, marginRight: "10px" }}
                ></i>
                {option?.descricao}
              </div>
            );
          }}
          onChange={(_, newValue) => onChangeMultiple(newValue, "tagsId")}
          value={value.multiple(tags, valueInput("tagsId"))}
          renderInput={(params) => (
            <TextField {...params} variant="outlined" label="Tags" />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          multiple
          id="marcasId"
          name="marcasId"
          options={marcas}
          noOptionsText="Sem opções"
          autoHighlight
          filterSelectedOptions
          getOptionLabel={(option) => option?.nome || ""}
          onChange={(_, newValue) => onChangeMultiple(newValue, "marcasId")}
          value={value.multiple(marcas, valueInput("marcasId"))}
          renderInput={(params) => (
            <TextField {...params} variant="outlined" label="Marcas" />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          multiple
          id="colecoesId"
          name="colecoesId"
          options={colecoes}
          noOptionsText="Sem opções"
          autoHighlight
          filterSelectedOptions
          getOptionLabel={(option) => option?.descricao || ""}
          onChange={(_, newValue) => onChangeMultiple(newValue, "colecoesId")}
          value={value.multiple(colecoes, valueInput("colecoesId"))}
          renderInput={(params) => (
            <TextField {...params} variant="outlined" label="Coleções" />
          )}
        />
      </Grid>
    </Grid>
  );
};

export default FormFiltroAvancado;
